import type { TemplateSection } from '../services/templateApi';

/**
 * Build a ProseMirror JSON document containing only section headings
 * from a template — no AI generation, instant.
 */
export function buildSkeletonDoc(
  sections: TemplateSection[],
  title: string,
): Record<string, unknown> {
  const content: Record<string, unknown>[] = [
    {
      type: 'heading',
      attrs: { level: 1 },
      content: [{ type: 'text', text: title }],
    },
    ...sections.flatMap((s) => [
      {
        type: 'heading',
        attrs: { level: 2 },
        content: [{ type: 'text', text: s.title }],
      },
      // Empty paragraph for the user / AI to fill in
      { type: 'paragraph' },
    ]),
  ];

  return { type: 'doc', content };
}
